import { Button, Col, Form, Row } from 'antd';
import { MemberCorpoPayload } from 'domain/entities/UserEntity';
import { FormInput } from 'presentation/components/form/FormInput.component';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import getMessage from 'utilities/constants/MESSAGE';
import { commonHelpers } from 'utilities/helpers';
import { MEMBER_TYPE_CORPORATION } from '../../CU-003-01';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';

const INPUT_TEXT_MAX_LENGTH = 100;

export const CompanyForm = () => {
    const navigate = useNavigate();

    const [btnDisable, setBtnDisable] = useState<boolean>(true);
    const [form] = Form.useForm();

    const onChangeForm = () => {
        form.validateFields({
            validateOnly: true,
        })
            .then(() => {
                setBtnDisable(false);
            })
            .catch((err) => {
                setBtnDisable(err.errorFields.length > 0);
            });
    };

    const submitNext = () => {
        const payload: MemberCorpoPayload = {
            ...form.getFieldsValue(),
            memberType: MEMBER_TYPE_CORPORATION,
            representativePhoneNumber: commonHelpers.toNumberOnly(
                form.getFieldValue('representativePhoneNumber'),
            ),
            picPhoneNumber01: commonHelpers.toNumberOnly(form.getFieldValue('picPhoneNumber01')),
            companyPostalCode: commonHelpers.toNumberOnly(form.getFieldValue('companyPostalCode')),
        };

        navigate(PRIVATE_ROUTES.PATH + '/' + PRIVATE_ROUTES.SUB.CU_007_01, {
            state: { data: payload, mode: 'create' },
        });
    };

    return (
        <>
            <Form
                form={form}
                className="w-full"
                onValuesChange={() => {
                    onChangeForm();
                }}
                onFinish={submitNext}
            >
                <Row className="min-w-min w-full">
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <FormInput
                                label="会社名"
                                name="companyName"
                                required
                                maxLength={INPUT_TEXT_MAX_LENGTH}
                                formatNumber={false}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                placeholder={PLACEHOLDER.COMPANY_NAME}
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <FormInput
                                label="会社名（カナ）"
                                name="companyNameKana"
                                maxLength={INPUT_TEXT_MAX_LENGTH}
                                required
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                placeholder={PLACEHOLDER.COMPANY_NAME_KANA}
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <FormInput
                                label="会社の郵便番号（ハイフンなし）"
                                name="companyPostalCode"
                                maxLength={7}
                                formatNumber={false}
                                type="postcode"
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                placeholder={PLACEHOLDER.POSTCODE}
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <FormInput
                                label="会社の所在地"
                                name="companyAddress"
                                required
                                maxLength={INPUT_TEXT_MAX_LENGTH}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                placeholder={PLACEHOLDER.ADDRESS}
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <FormInput
                                label="代表者名"
                                name="representativeName"
                                required
                                maxLength={INPUT_TEXT_MAX_LENGTH}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                placeholder={PLACEHOLDER.NAME}
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <FormInput
                                label="代表者名（カナ）"
                                name="representativeNameKana"
                                required
                                maxLength={INPUT_TEXT_MAX_LENGTH}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                placeholder={PLACEHOLDER.NAME_KANA}
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <FormInput
                                label="会社の電話番号（ハイフンなし）"
                                name="representativePhoneNumber"
                                type="phone"
                                required
                                maxLength={12}
                                formatNumber={false}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                placeholder={PLACEHOLDER.PHONE_NUMBER}
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <FormInput
                                label="担当者氏名"
                                name="picName"
                                required
                                maxLength={INPUT_TEXT_MAX_LENGTH}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                placeholder={PLACEHOLDER.NAME}
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <FormInput
                                label="担当者名（カナ）"
                                name="picNameKana"
                                required
                                maxLength={INPUT_TEXT_MAX_LENGTH}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                placeholder={PLACEHOLDER.NAME_KANA}
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <FormInput
                                label="担当者の連絡先（ハイフンなし）"
                                name="picPhoneNumber01"
                                required
                                type="phone"
                                maxLength={12}
                                formatNumber={false}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                placeholder={PLACEHOLDER.PHONE_NUMBER}
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <FormInput
                                label="担当者の連絡先（内線）"
                                name="picPhoneExt01"
                                type="number"
                                formatNumber={false}
                                maxLength={12}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                placeholder={PLACEHOLDER.PHONE_EXT_NUMBER}
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <FormInput
                                label="担当者のメールアドレス"
                                name="picEmail01"
                                required
                                type="email"
                                maxLength={255}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                rules={[
                                    {
                                        type: 'email',
                                        message: getMessage('Mail_Invalid'),
                                    },
                                ]}
                                placeholder={PLACEHOLDER.EMAIL}
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <FormInput
                                label="宅建業免許番号"
                                name="licenseNumber"
                                maxLength={50}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                placeholder={PLACEHOLDER.LICENSE_NUMBER}
                            />
                        </Col>
                    </Row>
                </Row>
                <Row justify="center" className="w-full mt-6">
                    <Col span={12}>
                        <Button
                            type="primary"
                            size="large"
                            disabled={btnDisable}
                            onClick={() => submitNext()}
                            className="button-container"
                        >
                            次へ
                        </Button>
                    </Col>
                </Row>
            </Form>
        </>
    );
};
